import React from 'react'
import ContentBlockHolder from './ContentBlocks/ContentBlockHolder'
import ContentBlock from './ContentBlocks/ContentBlock'

const Lifts = ({lifts}) => {
    if(lifts.length===1)
    {
        return (
            <ContentBlockHolder className="lifts">
                <ContentBlock align="center" fields={lifts[0]} />
            </ContentBlockHolder>
        );
    }
    else if(lifts.length>1)
    {
        let first = Object.assign(lifts[0],{"align":"left"});
        let second = Object.assign(lifts[1],{"align":"right"});
        return (
            <ContentBlockHolder className="dual lifts">
                <ContentBlock align="left" fields={first} />
                <ContentBlock align="right" fields={second} />
            </ContentBlockHolder>
        );
    } else {
        return null;
    }
}

export default Lifts;



// WEBPACK FOOTER //
// ./src/components/Lifts.js